import { parseDate } from '../helpers/parse-date';

const isBlank = (value) => value === undefined || value === null || String(value).trim() === '';

const projectRateCards = {
  'Client Name': {
    requirementType: 'required',
    description:
      'The name of the client associated with the project. This field must match the name of a client exactly, including spaces, punctuation and capitalization, otherwise the row may be skipped during import.',
    dataType: 'string',
    validator: (value) => !isBlank(value),
  },
  'Project Name': {
    requirementType: 'required',
    description:
      'The name of the project the rate belongs to. This field must match the name of a project exactly, including spaces, punctuation and capitalization, otherwise the row may be skipped during import.',
    dataType: 'string',
    validator: (value) => !isBlank(value),
  },
  'Start Date': {
    requirementType: 'optional',
    description:
      'The date the rate card takes effect, in "YYYY-MM-DD" or "MM/DD/YYYY" format. Leave blank to update the project\'s earliest rate card. A rate card starting on this date is created if the project does not have one, starting from the rates in effect that day. Requires Project Rate Cards to be enabled.',
    dataType: 'date',
    validator: (value) => isBlank(value) || !!parseDate(String(value).trim()),
  },
  'Member Email': {
    requirementType: 'optional',
    description:
      'The email address of a member already on the project. Provide either "Member Email" or "Role Name" on each row, not both.',
    dataType: 'email',
    validator: (value, row) =>
      isBlank(value)
        ? !isBlank(row?.['Role Name'])
        : isBlank(row?.['Role Name']) && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim()),
  },
  'Role Name': {
    requirementType: 'optional',
    description:
      'The name of a role already on the project. Provide either "Member Email" or "Role Name" on each row, not both.',
    dataType: 'string',
    validator: (value, row) => (isBlank(value) ? !isBlank(row?.['Member Email']) : isBlank(row?.['Member Email'])),
  },
  Rate: {
    requirementType: 'required',
    description: 'The billable rate for the member or role on the rate card.',
    dataType: 'number',
    validator: (value) => !isBlank(value) && !isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0,
  },
  Notes: {
    requirementType: 'optional',
    description: 'Notes for the rate card (max 5000 characters). Leave blank to keep the existing notes.',
    dataType: 'string',
    validator: (value) => isBlank(value) || String(value).length <= 5000,
  },
};

export default projectRateCards;
